// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import MasterService from '@services/masters'

export const getDesignation = createAsyncThunk('designation/getDesignation', async (params, { rejectWithValue }) => {
  try {
    const response = await MasterService.getAllDesignation(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getDesignationById = createAsyncThunk('designation/getDesignationById', async (id) => {
  const response = await MasterService.getDesignationById(id)
  return response
})

export const addDesignation = createAsyncThunk('designation/addDesignation', async (designation, { rejectWithValue }) => {
  try {
    const response = await MasterService.addDesignation(designation)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateDesignation = createAsyncThunk('designation/updateDesignation', async (designation, { rejectWithValue }) => {
  try {
    const response = await MasterService.updateDesignation(designation)
    return response
  } catch (err) {
    rejectWithValue(err.response.data)
  }
})

export const deleteDesignation = createAsyncThunk('designation/deleteDesignation', async (id, { dispatch, getState }) => {
  await MasterService.deleteDesignation(id)
  await dispatch(getDesignation(getState()?.designations.params))
  return id
})

export const designationSlice = createSlice({
  name: 'designation',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    individualDesignation: null,
    loading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDesignation.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getDesignationById.fulfilled, (state, action) => {
        state.individualDesignation = action.payload
        state.loading = false
      })
      .addCase(getDesignationById.pending, (state, action) => {
        state.individualDesignation = action.payload
        state.loading = true
      })
      .addCase(getDesignationById.rejected, (state, action) => {
        state.individualDesignation = action.payload
        state.loading = false
      })
  }
})

export default designationSlice.reducer
